export * from './adapter.js';
export * from './errors.js';
export { default as WalletConnectClient } from '@walletconnect/sign-client';